const $ = jQuery;

$(window).on('load', function(){
  console.log('Hello world from El Cultivo! --Load');

  /* L O G I N */
  $('#show_recover').on('click', function(e){
    e.preventDefault();
    $('#login_main').fadeOut(100);
    $('#login_recover').fadeIn(200);
  });
  $('#hide_recover').on('click', function(e){
    e.preventDefault();
    $('#login_recover').fadeOut(100);
    $('#login_main').fadeIn(200);
  });
  /* END L O G I N */
});
$(document).ready(function() {
  console.log('Hello world from El Cultivo! --Ready');
  let uri = window.location.origin + window.location.pathname;
  /* C O L L E C T I O N */
  $('.filter_toggle').on('click', function(){
    $(this).toggleClass('active');
    $(this).siblings('.filter_target').slideToggle(300);
  });
  $('input[name="sort"').on('change', function(){
    let sort_by = $(this).val();
    console.log('Order by ' + sort_by);
    let nextURL = uri + '?sort_by=' + sort_by;
    // This will create a new entry in the browser's history, without reloading
    window.history.pushState('', '', nextURL);

    // This will replace the current entry in the browser's history, without reloading
    window.history.replaceState('', '', nextURL);

    //Hot reload of products
    generalAjaxCall(nextURL);
  })
  /* END C O L L E C T I O N */
  /* B U N D L E */
  if( $('#bundle_tags').length ){
    let filters = $('#bundle_tags').find('[data-status="active"]');
    if( filters.length > 1){
      filters.each(function() {
        if ($(this).data('filter') !== 'all') {
          $(this).addClass('active');
        }
      });
    }else if( filters.length == 1){
      filters.addClass('active')
    }
  }
})

const generalAjaxCall = (nextURL) => {
  $.ajax({
      url: nextURL,
      type: 'GET',
      dataType: 'html',
      success: function(response){
        //Products
        let html = $( response ).find( '#grid-products' ).html();
        document.getElementById('grid-products').innerHTML = html; 
      }
  })
}

$('#menu_mobile_open').click(function(){
  $('#mobile_header').addClass('show');
});
$('#menu_mobile_close').click(function(){
  $('#mobile_header').removeClass('show');
})

$('.link_tab').on('click',function(){
  $(this).toggleClass('open-arrow');
  $(this).parent().find('.submenu').slideToggle('slow');                        
});

/* T A G S  B L O G */

let pathname = $(location).attr('href')
const tagName = pathname.split("/");
let elemnts = $(".tag-name");
if( pathname.includes('tagged') ){
elemnts.each(function( element ) {
    $(this).removeClass("active");
    if($(this).data("tag") == tagName[6]) {
        $(this).addClass("active");
    }
});
}else{
    $(elemnts[0]).addClass('active');
}


$('#slick-seller').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  infinite: false,
  centerMode: false,  
  prevArrow: "<div class='slick-prev arrow-s arrow-s--left'>",
  nextArrow: "<div class='slick-next arrow-s arrow-s--right'>",
  responsive: [
    {
      breakpoint: 768,
      settings: {
          infinite: false,
          centerMode: false,
          slidesToShow: 1,
          arrows:true,
      }
    }] 
});

$('#slick-steps').slick({
  infinite: true,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  cssEase: 'linear',
  fade: true,
  arrows: true,
  variableWidth:false,
  prevArrow: "<div class='slick-prev arrow-s arrow-s--left'>",
  nextArrow: "<div class='slick-next arrow-s arrow-s--right'>",
  responsive: [
        {
          breakpoint: 768,
          settings: {
              infinite: false,
              centerMode: false,
              slidesToShow: 1,
              arrows:true,
          }
        }] 
});

/* S I N G L E Product */
$(window).on('resize', function(){
  console.log('Resizing')
  if( $('#slider_single').length ){
    let info = $('.single-product__description').innerHeight() - 2;
    let win_h = $(window).innerHeight() - 2;
    if( (info > win_h) && $(window).width() > 901 ){
      $('.single-product__slide > .image-container').css('height', `${info}px`);
      $('.single-product__slide > .video-container').css('height', `${info}px`);
    }else{
      $('.single-product__slide > .image-container').css('height', `${win_h}px`);
      $('.single-product__slide > .video-container').css('height', `${win_h}px`);
    }
  }
});

$('.social-share-icon').on('click', function(){
  $(this).siblings('.social-share-buttons').addClass('active');
});
$('.btn_close_share').on('click', function(){
  $(this).parent('.social-share-buttons').removeClass('active');
})
function getFullProductURL() {
  return window.location.href;
}
  
function shareOnFacebook() {
  let productURL = getFullProductURL();
  window.open('https://www.facebook.com/sharer/sharer.php?u=' + productURL, '_blank');
}
  
function shareByEmail(title) {
  let productURL = getFullProductURL();
  let productTitle = title;
  window.location.href = 'mailto:?subject=' + productTitle + '&body=' + productURL;
}
  
function shareOnWhatsApp(title) {
  let productURL = getFullProductURL();
  let productTitle = title;
  window.open('https://api.whatsapp.com/send?text=' + productTitle + ': ' + productURL, '_blank');
}
  
function shareOnTwitter(title) {
  let productURL = getFullProductURL();
  let productTitle = title;
  window.open('https://twitter.com/intent/tweet?url=' + productURL + '&text=' + productTitle, '_blank');
}
if( $('#slider_single').length ){
  let info = $('.single-product__description').innerHeight() - 2;
  let win_h = $(window).innerHeight();
  if( (info > win_h) && $(window).width() > 901 ){
    $('.single-product__slide > .image-container').css('height', `${info}px`);
    $('.single-product__slide > .video-container').css('height', `${info}px`);
  }
  $('#slider_single').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 0,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 901,
        settings: {
            infinite: false,
            arrows: true,
            slidesToShow: 1,
            fade: true,
            prevArrow: "<div class='arrow-single arrow-single--left'>",
            nextArrow: "<div class='arrow-single arrow-single--right'>",
        }
      }] 
  });
  $(".arrow-single--left").click(function () {
    $("#slider_single").slick("slickPrev");
  });
  
  $(".arrow-single--right").click(function () {
    $("#slider_single").slick("slickNext");
  });
}
$('.toggle_tab').on('click', function(){
  let active = $('#tabs_container').find('[data-status="open"]');
  let isSameTab = active.is($(this).parent());
  
  if (active.length && (!isSameTab || active.children('.toggle_tab')[0] !== this)) {
    active.removeClass('active');
    active.children('.target_tab').slideUp(200);
    active.data('status', 'close');
    active.attr('data-status', 'close');
  }
  
  if (isSameTab) {
    active.removeClass('active');
    active.children('.target_tab').slideUp(200);
    active.data('status', 'close');
    active.attr('data-status', 'close');
  } else {
    $(this).parent().addClass('active');
    $(this).siblings('.target_tab').slideDown(200);
    $(this).parent().data('status', 'open');
    $(this).parent().attr('data-status', 'open');
  }
});
if( $('#slider_reviews').length ){
  $('#slider_reviews').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 200,
    autoplay: true,
    autoplaySpeen: 8000,
    arrows: false,
    infinite: true,
    centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 950,
        settings: {
            infinite: false,
            slidesToShow: 2
        }
      },
      {
        breakpoint: 650,
        settings: {
            slidesToShow: 1,
            variableWidth: false
        }
      }] 
  });
}
if($('#slider_related').length){
  $('#slider_related').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    centerMode: false,  
    prevArrow: "<div class='arrow-related arrow-related--left'>",
    nextArrow: "<div class='arrow-related arrow-related--right'>",
    responsive: [
      {
        breakpoint: 901,
        settings: {
            slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
            infinite: false,
            slidesToShow: 1
        }
      }] 
  });
}
/* END S I N G L E Product */

/* A C C O U N T */
const account_active = () => {
  let pathname = $(location).attr('href');
  let elements = $('.link_account');
  if( pathname.includes('account') ){
      elements .each(function() {
          $(this).addClass("active");
      });
  }
}
account_active();

$(".password_show").click(function() {
  const passwordInput = $(this).siblings(".input-e--account-password");
  if (passwordInput.attr("type") === "password") {
    passwordInput.attr("type", "text");
    $(this).addClass('hide');
    $(this).removeClass('show');
  } else {
    passwordInput.attr("type", "password");
    $(this).addClass('show');
    $(this).removeClass('hide');
  }
});
/* END A C C O U N T */